import { get } from 'lodash';
import React from 'react';
import RadioButton from '../../../components/forms/fields/RadioButton';
import { CellTemplateProps } from '../../../components/KendoDataGrid/KendoDataGrid.types';
import useStyles from '../styles';

const RadioCellTemplate: React.FC<CellTemplateProps<{}>> = ({
  field,
  dataItem,
}) => {
  const classes = useStyles();
  const id = Object.keys(dataItem)[0];
  const defaultValue = get(dataItem, [id, field], '') as boolean;

  return (
    <div className={classes.radioContainer}>
      <RadioButton
        label=""
        checked={defaultValue}
        disabled />
    </div>
  );
};

export default RadioCellTemplate;
